import { checkAuth } from "../auth/AuthContext";
import { parsePayload, throwCommError, OperationError, OperationIssue } from "../DAO";
import { Licence } from "./Licence";
import { Module, ProgramType } from "./LicenceOptions";

export interface LicenceFormData {
   instanceId: number,
   endDate: string,

   reportRequired: boolean,
   maxActiveUsers: number | null,
   maxActivePatients: number | null,
   moduleIds: number[],
   programTypeIds: number[]
}

export async function listLicences(): Promise<Licence[]> {
   const response = await fetch('../admin/licence/list', {
      'method': 'POST',
      'headers': {
         'Accept': 'application/json'
      }
   }).catch(throwCommError)
      .then(parsePayload)
      .then(checkAuth);
   if (response.success) {
      let value: any[];
      if (Array.isArray(response.value)) {
         value = response.value;
      }
      else {
         value = [];
      }
      return value.map(Licence.parse);
   }
   throw OperationError.from(response);
}

export async function listLicenceOptions(): Promise<{ modules: Module[], programTypes: ProgramType[] }> {
   const response = await fetch('../admin/licence/options', {
      'method': 'POST',
      'headers': {
         'Accept': 'application/json'
      }
   }).catch(throwCommError)
      .then(parsePayload)
      .then(checkAuth);
   if (response.success) {
      let arr: any[] = response.value?.modules;
      const modules: Module[] = (Array.isArray(arr) ? arr.map(Module.parse) : []);
      arr = response.value?.programTypes;
      const programTypes: ProgramType[] = (Array.isArray(arr) ? arr.map(ProgramType.parse) : []);

      const issues: OperationIssue[] = [];
      if (modules.length === 0) {
         issues.push({
            code: 'PARSE_INPUT',
            details: "The 'modules' list is missing or empty."
         });
      }
      if (programTypes.length === 0) {
         issues.push({
            code: 'PARSE_INPUT',
            details: "The 'programTypes' list is missing or empty."
         });
      }
      if (issues.length !== 0) {
         throw new OperationError().addIssues(issues);
      }
      return { modules, programTypes }
   }
   throw OperationError.from(response);
}


export async function addNewLicence(formData: LicenceFormData): Promise<void> {
   return saveLicence('add', formData);
}

export async function replaceExistingLicence(idToReplace: number, formData: LicenceFormData): Promise<void> {
   return saveLicence('replace', Object.assign({}, formData, { idToReplace: idToReplace }));
}

export async function updateExistingLicence(idToUpdate: number, formData: LicenceFormData): Promise<void> {
   return saveLicence('update', Object.assign({}, formData, { idToReplace: idToUpdate }));
}

export async function revokeLicence(idToRevoke: number): Promise<void> {
   return saveLicence('revoke', idToRevoke);
}

async function saveLicence(operation: string, formData: object | number): Promise<void> {
   const response = await fetch(`../admin/licence/${operation}`, {
      'method': 'POST',
      'headers': {
         'Content-Type': 'application/json',
         'Accept': 'application/json'
      },
      'body': JSON.stringify(formData)
   }).catch(throwCommError)
      .then(parsePayload)
      .then(checkAuth);
   if (!response.success) {
      throw OperationError.from(response);
   }
}
